import { render } from "./ProjectLogSidenav.vue?vue&type=template&id=905bdb94&scoped=true&ts=true"
import script from "./ProjectLogSidenav.vue?vue&type=script&lang=ts"
export * from "./ProjectLogSidenav.vue?vue&type=script&lang=ts"

import "./ProjectLogSidenav.vue?vue&type=style&index=0&id=905bdb94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905bdb94"]])

export default __exports__